import { Icon, ospThemes } from "@ospweb/sdk-ui";
import React from "react";
import { cn } from "utils";
import NextImage from "../../NextImage";
import Translations from "@translate/components/Chat/Charts/ChartFooter";
import { I18nUtil } from "@utils";
const I18n = I18nUtil.createScoped(Translations);
interface ChartFooterProps {
  dataSourceIcon?: React.ReactNode;
  supportedByIcon?: React.ReactNode;
  showDataSource?: boolean;
  startView?: React.ReactNode;
  className?: string;
}

const ChartFooter: React.FC<ChartFooterProps> = ({
  dataSourceIcon,
  supportedByIcon,
  showDataSource = true,
  startView,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-row items-center justify-between h-4",
        className,
      )}
    >
      {/* Data Sources with icon */}
      <div className="flex items-center">
        {startView
          ? startView
          : showDataSource && (
              <div className="flex items-center gap-1">
                <span className="body_s text-content_tertiary">
                  {I18n.t("Data Sources")}
                </span>
                <div className="w-[16px] h-[16px] rounded-full bg-background_white_overlay5 flex items-center justify-center">
                  {dataSourceIcon || (
                    <Icon
                      name="X-logo"
                      size={12}
                      color={ospThemes.colors.content_tertiary}
                    />
                  )}
                </div>
              </div>
            )}
      </div>
      {/* Powered by with icon */}
      <div className="flex flex-row items-center">
        <span className="body_medium_xs text-content_quaternary">
          {I18n.t("Supported by")}
        </span>
        {supportedByIcon || (
          // Placeholder icon when no custom icon is provided
          <NextImage
            width={22.58}
            height={12}
            src={"/assets/images/edgen-logo-v2.svg"}
            alt="Supported by"
            className="ml-1"
          />
        )}
      </div>
    </div>
  );
};

export default ChartFooter;
